@if (metric() === 'downloads') {
  <div class="charts-section metric-downloads">
    <ngx-charts-advanced-pie-chart
      [scheme]="colorScheme"
      label="{{ 'research.portal.download.map.total' | translate }}"
      [results]="downloadsByCountry()"
      (select)="onSelect($event)"
      (activate)="onHover($event)"
      (deactivate)="onUnHover()"
      [animations]="useAdvancedAnimation()"
      >
    </ngx-charts-advanced-pie-chart>
  </div>
}

@if (metric() === 'additions') {
  <div class="charts-section metric-additions">
    <ng-template #chartBar>
      <ngx-charts-bar-vertical
        #chart
        [view]="media.is('lt-md') ? [310, 200] : null"
        [scheme]="colorScheme"
        [results]="worksByYear()"
        [gradient]="gradient"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [title]="'research.portal.worksadded.title' | translate"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        yAxisLabel="{{ 'research.portal.works.added.yAxis.label' | translate }}"
        (select)="onSelect($event)"
        [roundEdges]="false"
        >
      </ngx-charts-bar-vertical>
    </ng-template>
    <ng-template #chartCard>
      <ngx-charts-number-card
        [view]="media.is('lt-md') ? [310, 200] : null"
        [animations]="true"
        [cardColor]="cardColor"
        [bandColor]="bandColor"
        [results]="totalWorks()"
        (select)="onSelect($event)"
        dir="ltr"
        >
      </ngx-charts-number-card>
    </ng-template>
    @if (media.is('gt-sm')) {
      <div class="chart-holder chart-bar">
        <ng-container *ngTemplateOutlet="chartBar"></ng-container>
      </div>
    }
    @if (media.is('gt-sm')) {
      <div class="chart-holder chart-card">
        <ng-container *ngTemplateOutlet="chartCard"></ng-container>
      </div>
    }
    @if (media.is('lt-md')) {
      <mulo-horizontaller
        [loading]="false"
        [buttonWidth]="media.is('sm') ? 74 : 32"
        [rtl]="i18nService.isLangRtl()"
        >
        <mulo-horizontaller-item>
          <ng-container *ngTemplateOutlet="chartBar"></ng-container>
        </mulo-horizontaller-item>
        <mulo-horizontaller-item>
          <ng-container *ngTemplateOutlet="chartCard"></ng-container>
        </mulo-horizontaller-item>
      </mulo-horizontaller>
    }
  </div>
}

@if (metric() === 'totals') {
  <div class="data metric-totals">
    <div class="metric-totals-content">
      @for (entry of totalAssets(); track entry) {
        <div class="metric-block">
          @if (entry.icon) {
            <mat-icon
              [class.mat-icon-rtl-mirror]="entry.icon === 'message-text'"
              [svgIcon]="entry.icon"
              muloSvgViewbox
            ></mat-icon>
          }
          <div>
            @if (loading()) {
              <content-loader
                [rtl]="i18nService.isLangRtl()"
                [style]="{ height: 32, width: 100 }"
                backgroundColor="#dddddd"
                foregroundColor="#eeeeee"
                viewBox="0,0,100,32"
                >
                <svg:rect height="32" rx="2" ry="2" width="100" x="0" y="0" />
              </content-loader>
            }
            @if (!loading() && useAdvancedAnimation()) {
              <div
                class="h1 metric-block-value"
                ngx-charts-count-up
                [countTo]="entry.value"
                [countFrom]="0"
                [countDuration]="1"
                >
                {{ entry.value }}
              </div>
            }
            @if (!loading() && !useAdvancedAnimation()) {
              <div class="h1 metric-block-value">
                {{ entry.value | number }}
              </div>
            }
            <span class="metric-block-title">{{ entry.name | translate }}</span>
          </div>
        </div>
      }
    </div>
  </div>
}
